module.exports = __webpack_public_path__ + "img/zlindex6.53d82ede.png";